import { FindBirthdateIndexInCategoryList } from './types/findBirthdateIndexInCategoryList.types'

export const findBirthdateIndexInCategoryList: FindBirthdateIndexInCategoryList = (
  birthdate,
  categoryBirthdatesList = []
) => (
  categoryBirthdatesList.findIndex(({ day, month, year }) => (
    year === birthdate?.year &&
    month === birthdate?.month &&
    day === birthdate?.day
  ))
)
